const initState = {
    isLoading: false,
    data: [],
    error: null,
  };
  
  const BirthdayReducer = (state = initState, action) => {
    switch (action.type) {
      case "SET_BIRTHDAY_LOADING":
        return {
          ...state,
          isLoading: true,
          error: null,
        };
      case "SET_BIRTHDAY_DATA":
        return {
          ...state,
          isLoading: false,
          data: action.payload,
        };
      case "SET_BIRTHDAY_ERROR":
        return {
          ...state,
          isLoading: false,
          data: [],
          error: action.payload,
        };
        case "SET_BIRTHDAY_RESET":
        return {
            ...state,
            isLoading: false,
            data: [],
            error: null,
        };
      default:
        return state;
    }
  };
  
  export default BirthdayReducer;